export default __webpack_public_path__ + "static/media/DPILogo_Horizontal_Charcoal_RGB.6488fa30.svg";